import React from 'react';
import { Snackbar, Alert, AlertColor, Link } from '@mui/material';
import { SnackbarProps } from '../../types';

const CustomSnackbar: React.FC<SnackbarProps> = ({ open, message, severity, linkLabel, linkOnClick, handleClose, autoHideDuration = 6000 }) => {
    const alertSeverity: AlertColor = ['error', 'warning', 'info', 'success'].includes(severity) 
    ? severity as AlertColor 
    : 'info';

    return (
        <Snackbar
            open={open}
            autoHideDuration={autoHideDuration}
            onClose={handleClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        >
            <Alert onClose={handleClose} severity={alertSeverity} sx={{ width: '100%' }}>
                <div dangerouslySetInnerHTML={{ __html: message }} />
                {linkLabel && linkOnClick ? <p style={{textAlign: 'center'}}><Link onClick={linkOnClick}>{linkLabel}</Link></p> : null}
            </Alert>
        </Snackbar>
    );
};

export default CustomSnackbar;
